import { useCallback } from "react";
import { useProfileData } from "hooks/use-profile-data.hook";
import { Options, useUpdateUserProfile } from "./use-update-user-profile.hook";

export const useUpdateTextNotifications = (options?: Options) => {
  const { updateUserProfile, isLoading } = useUpdateUserProfile({
    onError: options?.onError,
  });

  const { data } = useProfileData();
  const { mobilePhoneNumber: existingMobilePhoneNumber } = data ?? {};
  const currentDisableSms = data?.notificationPreferences?.disableSms;

  const updateTextNotifications = useCallback(
    async (
      mobilePhoneNumber: string | undefined,
      desiredDisableSms: boolean
    ) => {
      if (
        mobilePhoneNumber &&
        existingMobilePhoneNumber !== mobilePhoneNumber
      ) {
        await updateUserProfile({
          phone_numbers: [
            {
              description: "mobile",
              number: mobilePhoneNumber,
              countryCode: 0,
            },
          ],
        } as any);
      }
      if (currentDisableSms !== desiredDisableSms) {
        await updateUserProfile({
          notification_preferences: {
            disable_sms: desiredDisableSms,
          },
        });
      }
    },
    [updateUserProfile, existingMobilePhoneNumber, currentDisableSms]
  );

  return {
    updateTextNotifications,
    isLoading,
  };
};
